// extracted by mini-css-extract-plugin
export default {"container":"Header_container__MVRCx","heading":"Header_heading__EG+nJ","right":"Header_right__c4apT"};